<template>
  <div class="card">
    <div class="box boxShadow">
      <img :src="msg.banner" alt="">
      <div class="imgContent">
        <h4 class="textOver">{{ msg.serviceName }}</h4>
        <span>发布时间：{{ msg.createTime| DateFilter }}</span>
        <span class="float_right time">结束时间：{{ msg.endTime | DateFilter }}</span>
        <div>
          <span>目标单价：{{ msg.price }}</span>
          <span class="time float_right">类型描述：{{ msg.typeDesc }}</span>
        </div>
        <span class="time">送货地址或服务地点：{{ msg.provinceName }}{{ msg.cityName }}{{ msg.countyName }}{{ msg.address }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    msg: {
      type: Object,
      default: {},
    },
  },
  methods: {
    // goPath(serviceId) {
    //   this.$router.push({ path: `cooperationDetails/${serviceId}` });
    // },
  },
}
</script>


<style lang="scss" scoped>
.card {
  width: 590px;
  min-height: 126px;
  line-height: 26px;
  margin-bottom: 80px;
}
.box:hover {
  -webkit-box-shadow: 2px 2px 5px #666;
  box-shadow: 2px 2px 5px #666;
  border-radius: 4px;
}
.box {
  width: 590px;
  display: flex;
  float: left;
  height: 126px;
  background-color: #fff;
  cursor: pointer;
  &:first-of-type{
    margin-right: 20px;
  }
  img {
    width: 168px;
    height: 126px;
    border-radius: 4px 0 0 4px;
  }
  .imgContent {
    flex: 1;
    padding-left: 20px;
    padding-top: 15px;
    overflow: hidden;
    h4 {
      overflow: hidden;
      font-size: 20px;
      font-weight: 600;
      color: #333;
      line-height: 30px;
      width: 380px;
    }
    span {
        width: 182px;
        color: #666;
        word-wrap:break-word;
        line-height: 26px;
        overflow: hidden;
        font-size: 12px !important;
      }
      .float_right {
        float: right;
        height: 23px;
        padding-right: 40px;
        overflow: hidden !important;
      }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/navigator/bbs/components/List.vue